// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a7ce8c5e","893":"c2b0f7d2"}[chunkId] + ".chunk.js";
};